var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('md-menu-item',{on:{"click":_setup.handleDiscardChanges}},[_c('span',{staticClass:"actions-list-menu__item-icon discard-changes"}),_c('div',{staticClass:"navbar-button-title"},[_vm._v("Discard unpublished changes")])])
}
var staticRenderFns = []

export { render, staticRenderFns }